import React, { useEffect, useRef, useState } from "react";
import { FiChevronDown, FiCheck } from "react-icons/fi";

const CustomDropdown = ({
    value,
    onChange,
    options = [],
    placeholder = "Select an option",
    disabled = false,
    className = "",
    padding = "px-3 py-2",
    searchable = false,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const dropdownRef = useRef(null);
    const searchInputRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
                setSearchTerm("");
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (isOpen && (searchable || options.length > 8) && searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [isOpen, searchable, options.length]);

    const selectedOption = options.find((option) => option.value === value);

    const isSearchEnabled = searchable || options.length > 8;

    const filteredOptions = isSearchEnabled && searchTerm
        ? options.filter((opt) =>
            (opt.label || "").toLowerCase().includes(searchTerm.toLowerCase())
        )
        : options;

    const handleSelect = (option) => {
        onChange(option.value);
        setIsOpen(false);
        setSearchTerm("");
    };

    return (
        <div ref={dropdownRef} className={`position-relative w-100 ${className}`}>
            <button
                type="button"
                disabled={disabled}
                onClick={() => {
                    setIsOpen((prev) => !prev);
                    setSearchTerm("");
                }}
                className={`text-nowrap ${padding} w-100 d-flex align-items-center justify-content-between gap-2 bg-white text-start ${disabled ? "opacity-50" : ""}`}
                style={{
                    cursor: disabled ? "not-allowed" : "pointer",
                    minWidth: "150px",
                    fontSize: "13.5px",
                    fontWeight: 500,
                    color: "#1e293b",
                    border: isOpen ? "1.5px solid #0f766e" : "1.5px solid #e2e8f0",
                    borderRadius: "8px",
                    boxShadow: isOpen ? "0 0 0 3px rgba(15, 118, 110, 0.12)" : "0 1px 2px rgba(0, 0, 0, 0.04)",
                    transition: "all 0.2s ease",
                }}
            >
                <span className="text-truncate" style={{ fontWeight: 500 }}>
                    {selectedOption?.label || placeholder}
                </span>
                <FiChevronDown
                    size={17}
                    style={{
                        transition: "transform 0.2s ease",
                        transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                        flexShrink: 0,
                        color: isOpen ? "#0f766e" : "#64748b",
                    }}
                />
            </button>
            {isOpen && !disabled && (
                <div
                    className="position-absolute start-0 w-100 bg-white shadow-lg mt-1"
                    style={{
                        zIndex: 1050,
                        border: "1px solid #e2e8f0",
                        borderRadius: "10px",
                        boxShadow: "0 12px 28px -4px rgba(15, 23, 42, 0.16)",
                        fontSize: "13px",
                        overflow: "hidden",
                    }}
                >
                    {isSearchEnabled && (
                        <div className="p-2 border-bottom" style={{ borderColor: "#f1f5f9" }}>
                            <input
                                ref={searchInputRef}
                                type="text"
                                className="form-control form-control-sm"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{ fontSize: "12px", borderRadius: "6px" }}
                                onClick={(e) => e.stopPropagation()}
                            />
                        </div>
                    )}
                    <div style={{ maxHeight: "220px", overflowY: "auto", padding: "4px 0" }}>
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map((option) => {
                                const isSelected = option.value === value;
                                return (
                                    <button
                                        key={option.value}
                                        type="button"
                                        onClick={() => handleSelect(option)}
                                        className="w-100 border-0 text-nowrap text-start d-flex align-items-center justify-content-between"
                                        style={{
                                            cursor: "pointer",
                                            textAlign: "left",
                                            padding: "8px 14px",
                                            backgroundColor: isSelected ? "#f0fdfa" : "transparent",
                                            color: isSelected ? "#0f766e" : "#334155",
                                            fontWeight: isSelected ? 600 : 400,
                                            fontSize: "13px",
                                            transition: "background-color 0.15s ease",
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!isSelected) e.currentTarget.style.backgroundColor = "#f8fafc";
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!isSelected) e.currentTarget.style.backgroundColor = "transparent";
                                        }}
                                    >
                                        <span>{option.label}</span>
                                        {isSelected && (
                                            <FiCheck size={14} style={{ color: "#0f766e" }} />
                                        )}
                                    </button>
                                );
                            })
                        ) : (
                            <div className="px-4 py-3 text-muted text-center" style={{ fontSize: "12px" }}>
                                No results found
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CustomDropdown;